//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import { translate } from 'react-i18next';
import { FormField } from 'common/components/core/form/FormField';
import Switch from 'common/components/core/switch';
import defaultTheme from './FormFieldSwitch.scss';

const FormFieldSwitch = props => {
    const {
        theme,
        onChange,
        label,
        switchLabel,
        checked,
        t,
        children,
        error,
        hideLabel,
        disabled
    } = props;
    return (
        <FormField theme={theme} label={label} error={error}>
            <Switch
                label={
                    hideLabel
                        ? null
                        : switchLabel || checked
                        ? t('translations:yes')
                        : t('translations:no')
                }
                onChange={onChange}
                checked={checked}
                theme={theme}
                disabled={disabled}
            />
            {children}
        </FormField>
    );
};

const ThemedFormFieldSwitch = themr(
    'FormFieldSwitch',
    defaultTheme
)(translate()(FormFieldSwitch));
export { ThemedFormFieldSwitch as FormFieldSwitch };
export default ThemedFormFieldSwitch;
